export enum Orientation {
    TOP,
    RIGHT,
    BOTTOM,
    LEFT,
    VERTICAL_CENTER,
    HORIZONTAL_CENTER,
}